import { useSelector } from 'react-redux';
import { selectExperiments } from '../selectors/experiments';
import { selectPageSection } from '../selectors/pageSection';
import { AUD_DESKTOP_BX206_SEARCH_STRING_DESKTOP } from '../constants/experiments';
import { getExperimentGroup } from '../utils/getExperimentGroup';
import { ESectionType } from '../types/sectionType';

export const useSearchStringRedesignEnabled = () => {
  const experiments = useSelector(selectExperiments);
  const section = useSelector(selectPageSection);

  const abGroup = getExperimentGroup(experiments, AUD_DESKTOP_BX206_SEARCH_STRING_DESKTOP);
  const isEnabled = (abGroup && abGroup !== 'A' && section === ESectionType.Index) || false;

  return {
    isEnabled,
    experimentGroup: abGroup || undefined,
  };
};
